var floatRegex = /-?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)/g;
export { floatRegex };